interface AntdSorter {
  order: string
  [key: string]: any
}

interface AntdFilters {
  [key: string]: string[] | null
}

interface Options {
  filters?: AntdFilters
  sorter?: AntdSorter
}

interface Query {
  [key: string]: string
}

export default function (options: Options): Query {
  const sorterQuery: Query = {}
  const filterQuery: Query = {}

  if (options.sorter) {
    const sorter: AntdSorter = options.sorter

    if (sorter.order === "descend") {
      sorterQuery.ordering = `${sorter.columnKey}`
    } else if (sorter.order === "ascend") {
      sorterQuery.ordering = `-${sorter.columnKey}`
    }
  }

  if (options.filters) {
    const filters: AntdFilters = options.filters

    for (const key in filters) {
      const filter = filters[key]

      if (Array.isArray(filter) && filter.length) {
        filterQuery[key] = filter.join(",")
      }
    }
  }

  return {
    ...filterQuery,
    ...sorterQuery
  }
}
